import React, { useState } from 'react';
import _ from 'lodash';

import CellContent from './CellContent';
import { Information } from '../../modals/common';
import { getErrorValidateWithId } from '../../../utilities/works';
import { messageUtility } from '../../../utilities/messageUtility';
import Tippy, { ToolTip } from '../../ReactTippy';

const KeyPlanTemplate = ({
  context,
  msgValidate,
  column,
  tempWorkGroupImages,
  tabKeyStatus,
}) => {
  const [showDialog, setShowDialog] = useState(false);
  const {
    id,
    isAbortedOrApproved,
    work_date,
    field_tree_id,
    foreman_user_id,
    job_id,
  } = context.item;

  const getWorkGroup = () => {
    return _.find(tempWorkGroupImages, item =>
      _.isEqual(item.workGroupCondition, getWorkGroupCondition())
    );
  };

  const getKeyPlan = () => {
    const keyPlan = {
      keyPlanCode: null,
      keyPlanName: '',
    };
    const data = getWorkGroup();
    if (data) {
      let key = _.isEmpty(data.workGroupImageTmp)
        ? 'workGroupImage'
        : 'workGroupImageTmp';
      keyPlan['keyPlanCode'] =
        _.get(data, `${key}.key_plan_category_code`) || null;
      keyPlan['keyPlanName'] = _.get(data, `${key}.key_plan_name`) || '';
    }
    return keyPlan;
  };

  const getWorkGroupCondition = () => {
    return {
      work_date,
      field_tree_id,
      job_id,
      foreman_user_id,
    };
  };

  const getError = () => {
    return getErrorValidateWithId(msgValidate, context.item, column);
  };

  const isDataChanged = () => {
    return (
      _.get(context, `item.is_data_changed.work_key_plan_code`) &&
      _.get(getWorkGroup(), 'recordEdited') === id
    );
  };

  const getCurrentWorkGroup = () => {
    return _.find(tempWorkGroupImages, item =>
      _.isEqual(item.workGroupCondition, getWorkGroupCondition())
    );
  };

  const getImageUrl = () => {
    const data = getCurrentWorkGroup();
    if (data) {
      if (_.isEmpty(data.workGroupImageTmp)) {
        return _.get(data, 'workGroupImage.img_url', '');
      } else {
        const editedImage = _.get(data, `workGroupImageTmp.edited_image`);
        if (editedImage) {
          return editedImage;
        }
        return _.get(data, 'workGroupImageTmp.img_url', '');
      }
    }
    return '';
  };

  const renderImage = () => (
    <img src={getImageUrl()} alt={getKeyPlan()['keyPlanName']} />
  );

  return (
    <CellContent
      isDataChanged={isDataChanged()}
      errorMsg={getError()}
      errorTooltipId={`cell_${_.get(context, 'col.index')}_${_.get(
        context,
        'row.index'
      )}`}
      key={`${column}_${_.get(context, 'item.id')}`}
    >
      <div className='btn-dialog-cell'>
        <Tippy
          delay={[500, 0]}
          duration={10}
          arrow={true}
          arrowType='sharp'
          placement='top'
          html={<ToolTip>{getKeyPlan()['keyPlanName']}</ToolTip>}
        >
          <span className='keyplan-name'>{getKeyPlan()['keyPlanName']}</span>
        </Tippy>
        <button
          className={[
            getKeyPlan()['keyPlanName'] === '' ? 'btn-fixedsize--disabled' : '',
            'btn-fixedsize--sub btn-dialog',
          ].join(' ')}
          onClick={() => {
            !isAbortedOrApproved && setShowDialog(true);
          }}
          tabIndex={tabKeyStatus}
        >
          確認
        </button>
      </div>
      <Information
        visible={showDialog}
        title={getKeyPlan()['keyPlanName']}
        buttonText={messageUtility.getMessage('I-000-017')}
        rootClassName='dialog--wide'
        message={renderImage()}
        onClose={() => setShowDialog(false)}
      />
    </CellContent>
  );
};

export default KeyPlanTemplate;



// WEBPACK FOOTER //
// ./src/components/wijimo/templates/KeyPlanTemplate.jsx